import React, { Component } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import styled from "styled-components";

import PublicGraph from "../../components/graphs/PublicServicesGraph";
import MainGraph from "../../components/graphs/MainServicesGraph";
import CircleGraph from "../../components/graphs/CircleFillGraph";
import RadioButton from "../../components/RadioButton";
import ServicesDropdownIcon from "../../components/icons/ServicesDropdown";
import ChannelsDropdownIcon from "../../components/icons/ChannelsDropdown";
import Textfield from "../../components/TextField";
import MobileOnlyCloseIcon from "../../components/icons/MobileClose";
import {
  Main,
  GraphDetailContainer,
  MainArea,
  DetailArea,
  Title,
  Description,
  DropDownButton,
  DropdownGraphContainer,
  DropdownGraphChild,
  PageDetail,
  GraphTitle,
  CountData,
  CircleGraphsTitle,
  CirclesGraphContainer,
  SwitchButtonsWrap,
  SwitchButton,
  ActionsContainer,
  SingleCircle,
  SingleCircleDetail,
  CircleAndDetail
} from "../../components/StyledComponents";

import { servicesSettingsToggle, filterService } from "./data/actions";
import { toggleScroll } from "../../containers/data/actions";

const MobilePadding = styled.div`
  @media (max-width: 575px) {
    padding: 0 10px;
  }
`;

const SingleCircleDetailDropDown = styled.div`
  font-size: 9px;
  text-align: center;
  line-height: 14px;
  margin: 5px 0 20px 0;
  color: ${props => props.theme.text};
`;

const DropdownCircleGraphContainer = styled.div`
  height: 42.38px;
  width: 42.38px;

  @media (min-width: 1800px) {
    height: 55px;
    width: 55px;
  }
  @media (max-width: 575px) {
    height: 50px;
    width: 50px;
  }
`;

const DropdownCircleAndDetail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chosenGraph: "public",
      channelsDropdownOpen: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isSettingOpen !== this.props.isSettingOpen) {
      if (this.props.scroll) this.props.toggleScroll(false);
      else this.props.toggleScroll(true);
    }
  }

  handleSwitchGraph = chosenGraph => {
    this.setState({ chosenGraph });
  };

  handleChannelsDropdown = () => {
    this.setState({ channelsDropdownOpen: !this.state.channelsDropdownOpen });
  };

  handleGraphDropdown = chosen => {
    let { data } = this.props;

    let selectedCount = 0,
      isOnlyOneSelected = false;
    let itemIndex = data.findIndex(item => item.id === chosen);
    let isAllSelected = data.every(item => item.selected === true);

    data.forEach(item => {
      if (item.selected === true) selectedCount++;
    });
    if (selectedCount === 1 && data[itemIndex].selected === true)
      isOnlyOneSelected = true;

    if (isAllSelected) {
      data.map(item => {
        if (item.id !== chosen) item.selected = false;
        return item;
      });
    } else if (isOnlyOneSelected) {
      data.map(item => {
        item.selected = true;
        return item;
      });
    } else data[itemIndex].selected = !data[itemIndex].selected;

    this.setState({ data });
  };

  render() {
    const { chosenGraph, channelsDropdownOpen } = this.state;
    const {
      isSettingOpen,
      settingsClose,
      data,
      filterService,
      filteredData,
      isFiltered
    } = this.props;

    const serviceKPIsData = isFiltered ? filteredData : data;
    return (
      <Main>
        <GraphDetailContainer>
          <MainArea>
            {window.innerWidth > 575 && (
              <PageDetail>مجموع عدد الخدمات</PageDetail>
            )}
            {chosenGraph === "public" ? (
              <>
                <CountData>400 خدمة حكومية</CountData>

                <GraphTitle>
                  المؤشر المئوي لمجموع الخدمات للجهة الحكومية
                </GraphTitle>
                <PublicGraph onServiceFilter={filterService} />
              </>
            ) : (
              <>
                <CountData>8 خدمات رئيسية</CountData>

                <GraphTitle>المؤشر المئوي لمجموع الخدمات لجمارك دبي</GraphTitle>
                <MainGraph onServiceFilter={filterService} />
              </>
            )}
            <CircleGraphsTitle>متوسط أداء مؤشرات الخدمات </CircleGraphsTitle>
            <MobilePadding>
              <CirclesGraphContainer>
                {serviceKPIsData.map((item, i) => (
                  <CircleAndDetail key={`service-circle-${i}`}>
                    <SingleCircle>
                      <CircleGraph
                        key={i}
                        value={item.value}
                        title={item.name}
                      />
                    </SingleCircle>
                    <SingleCircleDetail>
                      {item.name}
                      <br />
                      {item.detail}
                    </SingleCircleDetail>
                  </CircleAndDetail>
                ))}
              </CirclesGraphContainer>
            </MobilePadding>
          </MainArea>
          <DetailArea mobileShow={isSettingOpen}>
            <Title>
              قنوات تقديم الخدمة <MobileOnlyCloseIcon onClick={settingsClose} />
            </Title>
            <Description>
              هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما
              سيلهي القارئ
            </Description>
            <ActionsContainer>
              <SwitchButtonsWrap>
                <SwitchButton
                  onClick={() => this.handleSwitchGraph("public")}
                  outlined={chosenGraph !== "public"}
                >
                  عامة
                </SwitchButton>
                <SwitchButton
                  onClick={() => this.handleSwitchGraph("main")}
                  outlined={chosenGraph !== "main"}
                >
                  رئيسية
                </SwitchButton>
              </SwitchButtonsWrap>
              <Textfield
                placeholder="بحث بإسم الخدمة"
                rounded
                icon={<ServicesDropdownIcon />}
              />
              <DropDownButton
                open={channelsDropdownOpen}
                size="small"
                onClick={this.handleChannelsDropdown}
                outlined={!channelsDropdownOpen}
              >
                <ChannelsDropdownIcon selected={channelsDropdownOpen} />
                <span> تقييم بإسم القنوات</span>
              </DropDownButton>
              {channelsDropdownOpen ? (
                <DropdownGraphContainer background>
                  {data.map(item => (
                    <DropdownGraphChild
                      onClick={() => this.handleGraphDropdown(item.id)}
                      selected={item.selected}
                      key={`dropdown-item-${item.id}`}
                    >
                      <DropdownCircleAndDetail>
                        <DropdownCircleGraphContainer>
                          <CircleGraph value={item.value} title={item.name} />
                        </DropdownCircleGraphContainer>
                        <SingleCircleDetailDropDown>
                          {item.name}
                        </SingleCircleDetailDropDown>
                      </DropdownCircleAndDetail>
                    </DropdownGraphChild>
                  ))}
                </DropdownGraphContainer>
              ) : (
                <>
                  <RadioButton
                    name="servicesByCategory"
                    label="خدمات حسب فئات المتعاملين"
                    options={[
                      { id: 1, label: "الخدمات الحكومية للافراد" },
                      { id: 2, label: "الخدمات الحكومية للشركات" },
                      { id: 3, label: "الخدمات الحكومية لجهة حكومية أخرى" }
                    ]}
                  />
                  <RadioButton
                    name="servicesByNature"
                    label="خدمات حسب طبيعة تقديمها"
                    options={[
                      { id: 1, label: "خدمات تأتي بطلب تصريح" },
                      { id: 2, label: "خدمات النفع العام" }
                    ]}
                  />
                </>
              )}
            </ActionsContainer>
          </DetailArea>
        </GraphDetailContainer>
      </Main>
    );
  }
}

const mapStateToProps = state => {
  return {
    isSettingOpen: state.services.isSettingOpen,
    data: state.services.data,
    filteredData: state.services.filteredData,
    isFiltered: state.services.isFiltered,
    scroll: state.app.scroll
  };
};

const mapDispatchToProps = {
  push,
  settingsClose: servicesSettingsToggle,
  filterService,
  toggleScroll
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Services);
